<div class="expanded-detail" [@detailExpand]="show ? 'expanded' : 'collapsed'">
  <div class="left">
    <h4>Produtos Transferidos</h4>
    <app-material-generic-table
      [dataSource]="data.transferData"
      [columnsDefinition]="columnDefinition"
      [displayedColumns]="displayedColumns"
      [emptyDataMessage]="'Nenhum produto transferido.'"
      >
    </app-material-generic-table>
  </div>
  <mat-divider vertical></mat-divider>
  <div class="right">
    <h4>{{infoLabel}}</h4>
    <div class="info-header-bar"></div>
    <div class="pallet-info-grid">
      <app-info-oc-or-nfe label="rfid" [value]="getPalletValues('rfid')"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Posição" [value]="getPalletValues('position')"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Nível" [value]="getPalletValues('levelName') || '---'"></app-info-oc-or-nfe>
      <div class="btn-container">
        <button mat-raised-button (click)="openPalletDetails(data)">DADOS DO PALLET</button>
      </div>
    </div>
  </div>
</div> 